import axios from 'axios'
import router from '@/router/index'
import store from '@/store/index'
import Cookies from 'vue-cookies'
import { Message } from 'element-ui';


// 创建一个axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  withCredentials: true,//跨域
  changeOrigin: true,
  // 使用简单请求(text/plain; charset=utf-8),复杂请求(多一次OPTIONS请求)可用 application/json
  headers: { 'Content-Type': 'application/json; charset=utf-8' }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    var token = null;

    if (store.state.userInfo.accessToken) {
      token = store.state.userInfo.accessToken
    }
    if (!token) {
      token = Cookies.get('accessToken')
      console.log('cookie accessToken:' + token)
    }
    if (token) {
      if (config.params) {
        config.params['accessToken'] = token
      } else {
        config.params = {
          accessToken: token
        };
      }
    }
    return config
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const status = response.status
    if (status != 200) {
      var errMsg = response.path + '(' + response.status + ')' + (response.error ? response.error : response.message)
      Message({
        showClose: true,
        message: dataAxios.message
      });
      return Promise.reject(response)
    }

    const dataAxios = response.data
    const { code } = dataAxios // response.data.status

    if (code === 0) {
      return response
    } else {
      if (code === 405) {
        reLogin()
      } else {
        Message({
          showClose: true,
          message: dataAxios.message
        });
      }
      return Promise.reject(response)
    }
  },
  error => {
    console.log(error)
  }
)


function reLogin() {
  router.push({ path : '/login' });
}


export default service



// WEBPACK FOOTER //
// ./src/utils/request.js